import React from "react";
import Activation from "../components/Activation/Activation";

const ActivationPage = () => {
  return (
    <div>
      <Activation />
    </div>
  );
};

export default ActivationPage;
